module.exports = __webpack_public_path__ + "img/tuxbuild_logo_orange.b9c3a318.svg";